import { asString } from './report-formatting.utils';
import { isRecord } from './report-json.utils';

export function getRealTyallsRowId(row: unknown): string {
   if (!isRecord(row)) {
      return '';
   }

   return asString(row['TyallsRowId'] ?? row['tyallsRowId']);
}

export function hasStableTyallsRowId(row: unknown): boolean {
   return getRealTyallsRowId(row) !== '';
}
